<mat-form-field>
  <mat-label>{{title}}</mat-label>
  <mat-select [(ngModel)]="selectedPointID" [ngModelOptions]="{standalone: true}">
    <mat-option *ngFor="let point of availablePoints" [value]="point.pointID">{{point.name}}</mat-option>
  </mat-select>
</mat-form-field>
